import { render } from "./c_Banner.vue?vue&type=template&id=1cbd183e"
const script = {}

import "../css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__